/**
 * Roles that grant platform-admin scope, compared case-insensitively.
 *
 * Mirrors PLATFORM_ADMIN_ROLES in
 * `packages/database/src/security/tenant-resolver.ts`, the set the server's
 * resolveEffectiveTenantId reads. A platform admin resolves to the apex
 * tenant whatever its tenantId claim says. The SPA cannot import that server
 * package, so a change to the list there changes it here in the same commit.
 */
export const PLATFORM_ADMIN_ROLES = ['aaim_super_admin', 'platform_admin', 'e2e_test_admin'] as const;

/**
 * True when any role is a platform-admin role; both sides lowercased. A
 * non-string entry never matches.
 */
export function hasPlatformAdminRole(roles: readonly unknown[] | null | undefined): boolean {
  return (roles ?? []).some(
    (role) =>
      typeof role === 'string' &&
      (PLATFORM_ADMIN_ROLES as readonly string[]).includes(role.toLowerCase()),
  );
}
